import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Cargo Handling',
  items: [
    {
      title: 'Automatic Unloading System',
      hasMaker: true,
      hasType: true,
      makers: ['Shinko', 'Teikoku', 'ISHII', 'Naniwa'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Ballast Pumps',
      hasMaker: true,
      hasType: true,
      makers: ['Shinko', 'Teikoku', 'ISHII'],
      standardServices: [
        {
          title: 'Overhauling/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Compressors',
      hasMaker: true,
      hasType: true,
      makers: [
        'Atlas Copco',
        'Burckhardt',
        'Corken',
        'Cryostar',
        'Mycom (Mayekawa)',
        'ABC Compressors',
        'Sulzer',
      ],
      standardServices: [
        {
          title: 'Compressor Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Control Console',
      hasMaker: true,
      hasType: true,
      makers: [
        'TGE',
        'LGE',
        'Wartsila',
        'Kongsberg',
        'Hoglund',
        'Misuzu',
        'Nakakita',
      ],
      standardServices: [
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Grabs',
      hasMaker: true,
      hasType: false,
      makers: ['Hijoy'],
      standardServices: [
        {
          title: 'Hydraulic Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Electrical Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Pins and Bushes Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Heat Exchangers',
      hasMaker: true,
      hasType: false,
      makers: ['Donghwa Entec', 'Cryostar', 'Hi Air'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Hold Hatches',
      hasMaker: true,
      hasType: false,
      makers: ['TTS', 'Macgregor', 'Nakata Mac', 'iknowmachinery', 'Imabari'],
      standardServices: [
        {
          title: 'Hydraulic Cylinders Service',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Rubber Packing Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Hydraulic Motors Service',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Rest Pads Build Up/Adjustment',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Chains Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Ultrasonic Tightness Testing',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Loading Computer',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Monitoring System (LTP)',
      hasMaker: true,
      hasType: true,
      makers: [
        'Kongsberg',
        'Emerson',
        'Musasino',
        'Wartsila',
        'Henri Systems',
        'Tokyo Keiki',
      ],
      standardServices: [
        {
          title: 'Adjustment/Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '5 Year Service/Calibration Certification',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Pumps',
      hasMaker: true,
      hasType: true,
      makers: [
        'Framo',
        'Shinko',
        'Svanehoj',
        'Hyundai',
        'Ebara',
        'Teikoku',
        'ISHII',
      ],
      standardServices: [
        {
          title: 'Pump Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Shafting Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Hydraulic Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Tanks and Insulation',
      hasMaker: true,
      hasType: false,
      makers: [
        'TI Marine',
        'Kaefer',
        'Dongsung Finetec',
        'Kangrim',
        'Passer Marine',
        'TGE',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Turbines',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Alignment',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'ESD System',
      hasMaker: true,
      hasType: true,
      makers: ['Trelleborg', 'MannTek', 'KLAW', 'Emerson'],
      standardServices: [
        {
          title: 'Control System Inspection',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Fuel Gas System',
      hasMaker: true,
      hasType: false,
      makers: ['Donghwa Entec', 'Wartsila'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Gas Detection System',
      hasMaker: true,
      hasType: true,
      makers: [
        'Draeger',
        'Consilium',
        'Hanla',
        'Bruusgaard',
        'Air Products',
        'Riken Keiki',
        'Emerson',
        'Komyo Rikigaku',
      ],
      standardServices: [
        {
          title: 'Electronic Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Sampling and Control Sensor System Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Inert Gas System',
      hasMaker: true,
      hasType: true,
      makers: [
        'Air Products',
        'Moss',
        'Kashiwa',
        'Smit',
        'Hamworthy',
        'Kangrim',
        'Wartsila',
        'Aalborg',
      ],
      standardServices: [
        {
          title: '5 Year Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Burner Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Health Test',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Control System Troubleshooting and Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [
        {
          title: 'Oxygen Analyzer',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Calibration',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Nitrogen Generator',
      hasMaker: true,
      hasType: true,
      makers: [
        'Oxymat',
        'Atlas Copco',
        'Alfa Laval',
        'Air Products',
        'Survitec - Wilhelmsen',
        'Scanjet',
      ],
      standardServices: [
        {
          title: '5 Year Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Compressor Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Membranes Inspection/Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Control System Troubleshooting and Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Overfill System',
      hasMaker: true,
      hasType: true,
      makers: ['Kongsberg', 'Emerson', 'Musasino', 'Wartsila', 'Henri Systems'],
      standardServices: [
        {
          title: 'Adjustment/Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '5 Year Service/Calibration Certification',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Pump Room Exhaust Fans',
      hasMaker: true,
      hasType: false,
      makers: ['Nishishiba', 'Hirose', 'Taiyo'],
      standardServices: [
        {
          title: 'Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Bearings Replacement',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Safety and PV Valves',
      hasMaker: true,
      hasType: true,
      makers: [
        'Fukui',
        'Pentair',
        'Korval',
        'Niikura Kogyo',
        'Pres-Vac',
        'Anderson Greenwood',
        'Top Safe',
      ],
      standardServices: [
        {
          title: 'Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Calibration/Pressure Testing',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Stripping Pumps',
      hasMaker: true,
      hasType: true,
      makers: ['Shinko', 'Naniwa'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Tank Cleaning Machines',
      hasMaker: true,
      hasType: true,
      makers: ['Alfa Laval', 'Scanjet'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'UTI',
      hasMaker: true,
      hasType: false,
      makers: ['MMC', 'Tanktech', 'Honeywell'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Vacuum Pumps',
      hasMaker: true,
      hasType: true,
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
